import './ResultMark.scss';
import React from 'react';
import clsx from 'clsx';

export type ResultMarkState = 'loading' | 'finishing' | 'done';
export type ResultMarkTone = 'neutral' | 'ok' | 'err';

export interface IResultMarkProps {
    /** `loading` — дуга крутится; `finishing` — дуга дорисовывается до кольца и красится по `tone`; `done` — итог. */
    state: ResultMarkState;
    tone?: ResultMarkTone;
    /** Сторона знака в px. */
    size?: number;
    className?: string;
}

/**
 * Знак хода операции: лоадер со значком файла, который дорисовывается в галочку (`ok`) или «!» (`err`).
 * Один DOM-узел на все состояния — переходы между ними анимируются, а не подменяются.
 */
const ResultMark = ({ state, tone = 'neutral', size = 104, className }: IResultMarkProps) => (
    <div
        className={clsx('result-mark', `result-mark--${state}`, `result-mark--${tone}`, className)}
        style={{ '--result-mark-size': `${size}px` } as React.CSSProperties}
        data-testid="result-mark"
        data-state={state}
        data-tone={tone}
    >
        <span className="result-mark__ripple" />
        <div className="result-mark__pop">
            <svg className="result-mark__svg" width={size} height={size} viewBox="0 0 88 88" aria-hidden="true">
                <circle className="result-mark__fill" cx="44" cy="44" r="30" />
                <circle className="result-mark__track" cx="44" cy="44" r="30" />
                <g className="result-mark__spin">
                    <circle className="result-mark__arc" cx="44" cy="44" r="30" transform="rotate(-90 44 44)" />
                </g>
                <g className="result-mark__doc">
                    <path d="M39 33h7.5l5.5 5.5V54a1 1 0 0 1-1 1H39a1 1 0 0 1-1-1V34a1 1 0 0 1 1-1z" />
                    <path d="M46.5 33v5.5H52M42 45h7M42 49.5h5" />
                </g>
                <path className="result-mark__check" d="M31 45l9 9 17-19" />
                <g className="result-mark__bang">
                    <path d="M44 32v15" />
                    <path d="M44 55.5v.5" />
                </g>
            </svg>
        </div>
    </div>
);

export default ResultMark;
